module.exports = __webpack_public_path__ + "static/img/5.e08e898.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/7/zh/5.png
// module id = fqji
// module chunks = 0